import * as ng from 'angular';

const defaultTitle = 'Your request is being processed...';
const defaultMessage = 'This may take several moments, please stand by.';

export class LoaderService {
   isLoading = false;

   showSpinner() {
      if (this.isLoading) {
         return;
      }

      this.isLoading = true;

      $('.blocking-loader').show();
      $('.blocking-bg').show();
      $('.blocking-spinner-standalone').show();
   }

   showMessage(title?:string, message?:string) {
      if (this.isLoading) {
         return;
      }

      this.isLoading = true;

      let domTitle = defaultTitle;
      let domMessage = defaultMessage;

      if (!message && title) {
         domMessage = title;
      } else if (message && title) {
         domMessage = message;
         domTitle = title;
      }

      $('.blocking-loader').show();
      $('.blocking-bg').show();
      $('.blocking-message').html(`<h2>${domTitle}</h2>${domMessage}`);
      $('.blocking-panel').addClass('animated slideInDown').show();
   }

   hide() {
      if (!this.isLoading) {
         return;
      }

      this.isLoading = false;

      $('.blocking-loader').fadeOut();
      $('.blocking-spinner-panel').fadeOut();
      $('.blocking-spinner-standalone').fadeOut();
      $('.blocking-panel').fadeOut();
   }
}

ng.module('e360').service('loader', LoaderService);
